module.exports = __webpack_public_path__ + "static/media/gallery4.5d7e0616.jpg";